import { ref } from '@vue/composition-api'
import { validateForm } from '@core/utils/validations/utils'

import router from '@/router'
import store from '@/store'




export default function useAuthentication() {
    const form = ref()
    const email = ref('')
    const password = ref('')
    const password_confirm = ref('')

    const passwordFieldType = ref('password')
    const passwordConfirmFieldType = ref('password')


    const loading = ref(false)


    const login = async () => {
        loading.value = true
        let validate = await validateForm(form.value).catch(()=>{})
        if (validate)
            await store.dispatch('auth/login', {'email': email.value, 'password': password.value}).catch(()=>{})
        loading.value = false
    }

    const register = async () => {
        loading.value = true
        let validate = await validateForm(form.value).catch(()=>{})
        if (validate)
            await store.dispatch('auth/register', { 'email': email.value, 'password1': password.value, 'password2': password.value}).catch(()=>{})
        loading.value = false
    }

    const sendPasswordResetEmail = async () => {
        loading.value = true
        let validate = await validateForm(form.value).catch(()=>{})
        if (validate)
            await store.dispatch('auth/sendPasswordResetEmail', {'email': email.value}).catch(()=>{})
        loading.value = false
    }

    const resetPassword = async () => {
        loading.value = true
        let validate = await validateForm(form.value).catch(()=>{})
        if (validate)
            await store.dispatch('auth/resetPassword', {'new_password1': password.value, 'new_password2': password_confirm.value, 'id': router.currentRoute.params["id"], 'token': router.currentRoute.params["token"]}).catch(()=>{})
        loading.value = false
    }

    return {
        form,

        email,
        password,
        password_confirm,

        passwordFieldType,
        passwordConfirmFieldType,
        loading,

        login,
        register,
        sendPasswordResetEmail,
        resetPassword

    }
}
